/** Public marketing site URL (production hosting). */
export const SITE_URL = "https://burn-chart.com";

export const SITE_NAME = "BurnChart";

export const SITE_LEGAL_NAME = "Soki Creative LLC";

export const DEFAULT_OG_IMAGE = `${SITE_URL}/logo.svg`;

export const LANDING_SEO = {
  title:
    "BurnChart | Startup Runway Calculator, Burn Chart & Financial Model Software",
  description:
    "BurnChart is an interactive startup runway calculator and burn chart app for founders. Model cash runway, burn rate, revenue, fundraising, and investor-ready business plans — free to start, Pro for AI advisor and multiple startups.",
  keywords: [
    "startup runway calculator",
    "burn chart software",
    "startup financial model",
    "cash runway planning",
    "burn rate calculator",
    "startup burn chart",
    "fundraising financial model",
    "runway forecasting",
    "SaaS financial planning",
    "investor burn chart",
    "startup cash flow model",
    "interactive burn down chart",
    "business plan from financial model",
    "AI startup financial advisor",
  ].join(", "),
} as const;

export const SIGNUP_SEO = {
  title: "Sign Up Free | BurnChart Startup Runway Calculator",
  description:
    "Create your free BurnChart account. Model startup runway, burn rate, and revenue in an interactive timeline — no credit card required.",
} as const;

export const SIGNIN_SEO = {
  title: "Sign In | BurnChart",
  description: "Sign in to your BurnChart account to view your burn chart and runway model.",
} as const;
